export { default } from './smartphone'
